import React, { Fragment } from 'react'
import styles from './MetaBlock.scss'
import { Icon } from 'common/LegacyIcon'
import { Block } from '../Block'
import { getCurrentUser } from 'lib/utils'
import { useFormatMessage, commonNouns } from 'lib/localization'
import { Modifier, SelectionState, EditorState } from 'draft-js'
import { defineMessages } from 'react-intl'

const messages = defineMessages({
  insertNew: {
    id: 'MetaBlock.insertNew',
    defaultMessage: 'Insert a new block'
  },
  imageGallery: {
    id: 'MetaBlock.imageGallery',
    defaultMessage: 'Image/Gallery'
  },
  climbReplay: {
    id: 'MetaBlock.climbReplay',
    defaultMessage: 'Climb Replay'
  },
  text: {
    id: 'MetaBlock.text',
    defaultMessage: 'Text'
  }
})

const blockTypes = [
  {
    type: 'gallery',
    icon: 'gallery',
    label: messages.imageGallery
  },
  {
    type: 'map',
    icon: 'map',
    label: commonNouns.map
  },
  {
    type: 'climb',
    icon: 'elevation',
    label: messages.climbReplay
  }
]

export const MetaBlock = ({ appendBlock, block, blockProps }) => {
  const fm = useFormatMessage()
  return <Block block={block} blockProps={blockProps}>
    <div className={styles.MetaBlock}>
      <h2>{fm(messages.insertNew)}:</h2>
      <div className={styles.blockList}>
        {blockTypes.map(({ type, icon, label }) => (
          <div key={type} className={styles.blockItem} onClick={() => blockProps.onChange({ type })}>
            <Icon i={icon} size={40} />
            <span>{fm(label)}</span>
          </div>
        ))}
        <div className={styles.blockItem} onClick={() => makeUnstyled(block, blockProps)}>
          <Icon i='paragraph' size={40} />
          <span>{fm(messages.text)}</span>
        </div>
      </div>
      {getCurrentUser().accountLevel === 11 && <Fragment>
        <hr />
        <div className={styles.adminBlocks}>
          <span>these ones are admin-only</span>
          <div className={styles.blockItem} onClick={() => blockProps.onChange({ type: 'route' })}>
            <Icon i='farthingWithFlat' size={40} />
            <span>troute embed</span>
          </div>
          <div className={styles.blockItem} onClick={() => blockProps.onChange({ type: 'embed' })}>
            <Icon i='chainring' size={40} />
            <span>video/img embed</span>
          </div>
        </div>
      </Fragment>}
    </div>
  </Block>
}

const makeUnstyled = (block, { getEditorState, setEditorState }) => {
  const editorState = getEditorState()
  const target = SelectionState.createEmpty(block.getKey()).set('hasFocus', true)
  const newContent = Modifier.setBlockType(editorState.getCurrentContent(), target, 'unstyled')
    .set('selectionAfter', target)
  const newState = EditorState.push(
    editorState,
    newContent,
    'change-block-type'
  )
  setEditorState(newState)
}
